import * as ContactMeta from './ContactMeta.jsx';
import { Blocks as LineItemCellBlocks } from '../common/LineItemCell.jsx';
import { ContainerTypeConfig as LineItemCellTypeConfig, MetaTokens as LineItemCellMetaTokens } from './LineItemCell.jsx';
import * as LineItems from './LineItems.jsx';
import * as MetaDate from '../common/MetaDate.jsx';
import * as MetaName from './MetaName.jsx';
import * as MetaNotes from '../common/MetaNotes.jsx';
import * as MetaNumber from './MetaNumber.jsx';
import * as MetaStaff from '../common/MetaStaff.jsx';
import * as MetaStage from './MetaStage.jsx';
import * as MetaTrackingNumber from './MetaTrackingNumber.jsx';
import Name from '../utility/Name.jsx';

const Blocks = {
    get: (group, data) => [
        {
            id: 'purchaseOrderSeparator',
            dataType: 'separator',
            display: 'Purchase Order',
            group
        },
        {
            id: Name.Block.Client.ContactMeta,
            component: ContactMeta.Component,
            config: {
                Block: ContactMeta.TypeConfig.panel.block(),
                Style: ContactMeta.TypeConfig.panel.style()
            },
            display: 'Contact Meta',
            group,
            image: ''
        },
        {
            id: Name.Block.Name,
            component: MetaName.Component,
            config: {
                Block: MetaName.TypeConfig.panel.block(),
                Style: MetaName.TypeConfig.panel.style(),
                Description: MetaName.TypeConfig.panel.description(),
                Label: MetaName.TypeConfig.panel.label(),
                Value: MetaName.TypeConfig.panel.value()
            },
            display: 'Purchase Order Name',
            group,
            image: ''
        },
        {
            id: Name.Block.Number,
            component: MetaNumber.Component,
            config: {
                Block: MetaNumber.TypeConfig.panel.block(),
                Style: MetaNumber.TypeConfig.panel.style(),
                Description: MetaNumber.TypeConfig.panel.description(),
                Label: MetaNumber.TypeConfig.panel.label(),
                Value: MetaNumber.TypeConfig.panel.value()
            },
            display: 'Purchase Order Number',
            group,
            image: ''
        },
        {
            id: Name.Block.Date,
            component: MetaDate.Component,
            config: {
                Block: MetaDate.TypeConfig.panel.block(),
                Style: MetaDate.TypeConfig.panel.style(),
                Description: MetaDate.TypeConfig.panel.description(),
                Label: MetaDate.TypeConfig.panel.label(),
                Value: MetaDate.TypeConfig.panel.value()
            },
            display: 'Purchase Order Date',
            group,
            image: ''
        },
        {
            id: Name.Block.Company.StaffName,
            component: MetaStaff.Component,
            config: {
                Block: MetaStaff.TypeConfig.panel.block(),
                Style: MetaStaff.TypeConfig.panel.style(),
                Description: MetaStaff.TypeConfig.panel.description(),
                Label: MetaStaff.TypeConfig.panel.label(),
                Value: MetaStaff.TypeConfig.panel.value(),
                Visibility: MetaStaff.TypeConfig.panel.visibility()
            },
            display: 'User Name',
            group,
            image: ''
        },
        {
            id: Name.Block.TrackingNumber,
            component: MetaTrackingNumber.Component,
            config: {
                Block: MetaTrackingNumber.TypeConfig.panel.block(),
                Style: MetaTrackingNumber.TypeConfig.panel.style(),
                Description: MetaTrackingNumber.TypeConfig.panel.description(),
                Label: MetaTrackingNumber.TypeConfig.panel.label(),
                Value: MetaTrackingNumber.TypeConfig.panel.value()
            },
            display: 'Tracking Number',
            group,
            image: ''
        },
        {
            id: Name.Block.Stage,
            component: MetaStage.Component,
            config: {
                Block: MetaStage.TypeConfig.panel.block(),
                Style: MetaStage.TypeConfig.panel.style(),
                Description: MetaStage.TypeConfig.panel.description(),
                Label: MetaStage.TypeConfig.panel.label(),
                Value: MetaStage.TypeConfig.panel.value()
            },
            display: 'Stage',
            group,
            image: ''
        },
        {
            id: Name.Block.Notes,
            component: MetaNotes.Component,
            config: {
                Block: MetaNotes.TypeConfig.panel.block(),
                Style: MetaNotes.TypeConfig.panel.style(),
                Description: MetaNotes.TypeConfig.panel.description(),
                Label: MetaNotes.TypeConfig.panel.label(),
                Value: MetaNotes.TypeConfig.panel.value(),
                Visibility: MetaNotes.TypeConfig.panel.visibility('Purchase Order Notes')
            },
            display: 'Purchase Order Notes',
            group,
            image: ''
        },
        {
            id: Name.Block.Inventory.List,
            component: LineItems.Component,
            config: {
                Block: LineItems.TypeConfig.panel.block(),
                Style: LineItems.TypeConfig.panel.style(),
                Visibility: LineItems.TypeConfig.panel.visibility(),
                defaults: [
                    { configName: 'Block', propertyName: 'design', propertyValue: LineItemCellTypeConfig.defaultDesign(data) }
                ]
            },
            display: 'Line Items',
            group,
            image: ''
        },
        // {
        //     id: Name.Block.Total.Subtotal,
        //     component: Totals.Subtotal.Component,
        //     config: {
        //         Block: Totals.Subtotal.TypeConfig.panel.block(),
        //         Style: Totals.Subtotal.TypeConfig.panel.style(),
        //         Label: Totals.Subtotal.TypeConfig.panel.label(),
        //         Value: Totals.Subtotal.TypeConfig.panel.value(data)
        //     },
        //     display: 'Subtotal',
        //     group,
        //     image: ''
        // },
        // {
        //     id: Name.Block.Total.Taxes,
        //     component: Totals.Taxes.Component,
        //     config: {
        //         Block: Totals.Taxes.TypeConfig.panel.block(),
        //         Style: Totals.Taxes.TypeConfig.panel.style(),
        //         Label: Totals.Taxes.TypeConfig.panel.label(),
        //         Value: Totals.Taxes.TypeConfig.panel.value(data)
        //     },
        //     display: 'Taxes',
        //     group,
        //     image: ''
        // },
        // {
        //     id: Name.Block.Total.Shipping,
        //     component: Totals.Shipping.Component,
        //     config: {
        //         Block: Totals.Shipping.TypeConfig.panel.block(),
        //         Style: Totals.Shipping.TypeConfig.panel.style(),
        //         Label: Totals.Shipping.TypeConfig.panel.label(),
        //         Value: Totals.Shipping.TypeConfig.panel.value(data)
        //     },
        //     display: 'Shipping Cost',
        //     group,
        //     image: ''
        // },
        // {
        //     id: Name.Block.Total.GrandTotal,
        //     component: Totals.GrandTotal.Component,
        //     config: {
        //         Block: Totals.GrandTotal.TypeConfig.panel.block(),
        //         Style: Totals.GrandTotal.TypeConfig.panel.style(),
        //         Label: Totals.GrandTotal.TypeConfig.panel.label(),
        //         Value: Totals.GrandTotal.TypeConfig.panel.value(data)
        //     },
        //     display: 'Grand Total',
        //     group,
        //     image: ''
        // }
    ]
};
const Content = {
    [Name.Block.Inventory.List]: LineItemCellBlocks
};
const Tokens = {
    get: (id, data) => {
        switch (id) {
            case Name.Block.Client.ContactMeta:
                return ContactMeta.Tokens();
            case Name.Block.Company.StaffName:
                return MetaStaff.Tokens();
            case Name.Block.Date:
                return MetaDate.Tokens();
            case Name.Block.Inventory.Meta:
                return LineItemCellMetaTokens(data);
            case Name.Block.Name:
                return MetaName.Tokens();
            case Name.Block.Number:
                return MetaNumber.Tokens(Name.Config.PurchaseOrder);
            case Name.Block.Stage:
                return MetaStage.Tokens();
            case Name.Block.TrackingNumber:
                return MetaTrackingNumber.Tokens();
            // case Name.Block.Total.GrandTotal:
            //     return Totals.GrandTotal.Tokens(data);
            // case Name.Block.Total.Shipping:
            //     return Totals.Shipping.Tokens(data);
            // case Name.Block.Total.Subtotal:
            //     return Totals.Subtotal.Tokens(data);
            // case Name.Block.Total.Taxes:
            //     return Totals.Taxes.Tokens(data);
        }
    }
};

export {
    Blocks,
    Content,
    Tokens
}